import { render } from "./AudioFile.vue?vue&type=template&id=3f31892e"
import script from "./AudioFile.vue?vue&type=script&lang=js"
export * from "./AudioFile.vue?vue&type=script&lang=js"
script.render = render

export default script